import { render, staticRenderFns } from "./siPurchaseGoodsDetails.vue?vue&type=template&id=10d7a58b&scoped=true&"
import script from "./siPurchaseGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./siPurchaseGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./siPurchaseGoodsDetails.vue?vue&type=style&index=0&id=10d7a58b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7a58b",
  null
  
)

component.options.__file = "siPurchaseGoodsDetails.vue"
export default component.exports